import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Users, ArrowRight, Clock, CheckCircle2 } from 'lucide-react';

export default function MembershipSuccessPage() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleHome = () => {
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen svh-canvas flex flex-col items-center justify-center px-4 py-16">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: mounted ? 1 : 0, y: mounted ? 0 : 24 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-[560px]"
      >
        {/* Brand header */}
        <div className="text-center mb-8">
          <img
            src="/photos/Image.jpeg"
            alt="SV Heinersreuth"
            className="h-14 w-14 rounded-full object-cover mx-auto mb-3 shadow-sm ring-1 ring-black/5"
          />
          <p className="text-[15px] font-bold tracking-tight" style={{ color: 'var(--svh-ink)' }}>
            SV Heinersreuth
          </p>
          <p className="svh-label mt-1">Padel &amp; Tennis</p>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3, delay: 0.1 }}
          className="svh-card svh-card-lg svh-card-raised overflow-hidden"
        >
          <div className="h-1 w-full" style={{ background: 'var(--svh-crest)' }} />
          <div className="p-8 md:p-10">
            {/* Icon */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4, delay: 0.2 }}
              className="flex items-center justify-center mb-6"
            >
              <div className="w-16 h-16 rounded-full bg-emerald-50 flex items-center justify-center">
                <Users className="w-8 h-8 text-emerald-600" strokeWidth={1.75} />
              </div>
            </motion.div>

            {/* Headline */}
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: 0.25 }}
              className="text-center mb-8"
            >
              <p className="text-[12px] font-bold tracking-[0.16em] uppercase text-emerald-700 mb-3">
                Mitgliedschaftsanfrage
              </p>
              <h1 className="svh-h2 mb-4">Wir haben Ihre Anfrage erhalten</h1>
              <p className="svh-body">
                Herzlichen Glückwunsch zum ersten Schritt. Wir freuen uns auf Sie und melden uns in Kürze mit allen Details.
              </p>
            </motion.div>

            {/* Info panel */}
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: 0.3 }}
              className="rounded-[10px] px-5 py-4 mb-6 space-y-4"
              style={{ background: 'var(--svh-surface-sub)', border: '1px solid var(--svh-border)' }}
            >
              <div className="flex items-start gap-3">
                <Clock className="w-4 h-4 flex-shrink-0 mt-0.5" style={{ color: 'var(--svh-ink-3)' }} strokeWidth={2} />
                <div>
                  <p className="svh-label mb-0.5">Rückmeldung</p>
                  <p className="text-[14px] font-semibold" style={{ color: 'var(--svh-ink)' }}>
                    Innerhalb von 24 Stunden
                  </p>
                </div>
              </div>
              <hr className="svh-rule" />
              <div className="flex items-start gap-3">
                <CheckCircle2 className="w-4 h-4 flex-shrink-0 mt-0.5" style={{ color: 'var(--svh-ink-3)' }} strokeWidth={2} />
                <div>
                  <p className="svh-label mb-0.5">Status</p>
                  <p className="text-[14px] font-semibold" style={{ color: 'var(--svh-ink)' }}>
                    Anfrage erfolgreich übermittelt
                  </p>
                </div>
              </div>
              <hr className="svh-rule" />
              <div className="flex items-start gap-3">
                <Users className="w-4 h-4 flex-shrink-0 mt-0.5" style={{ color: 'var(--svh-ink-3)' }} strokeWidth={2} />
                <div>
                  <p className="svh-label mb-0.5">Nächste Schritte</p>
                  <p className="text-[14px] font-semibold" style={{ color: 'var(--svh-ink)' }}>
                    Persönliche Beratung &amp; Unterlagen
                  </p>
                </div>
              </div>
            </motion.div>

            <hr className="svh-rule mb-6" />

            {/* CTA */}
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: 0.35 }}
            >
              <button onClick={handleHome} className="svh-btn svh-btn--primary svh-focus w-full">
                Zur Startseite
                <ArrowRight className="w-4 h-4" />
              </button>
            </motion.div>
          </div>
        </motion.div>

        <p className="svh-meta text-center mt-6">SV Heinersreuth e.V.</p>
      </motion.div>
    </div>
  );
}
